import { Suspense, useCallback, useEffect } from "react";

import routes from './Routes/routes';

import {  RouterProvider } from "react-router-dom";

import i18n from "./Utils/i18n";
import Loading from "./Components/Loading"

function App() {

  const changeLanguage = useCallback(() => {

    i18n.on("languageChanged", (local) => {
       
      let direction = i18n.dir(local);
      document.body.dir = direction;
      
     });
  }, [])
  
  useEffect(() => {

    changeLanguage();

  }, [changeLanguage]);

  return (
    <Suspense fallback={<Loading />}>
      <RouterProvider router={routes}/>
    </Suspense>
  );
}

export default App;